<template>
  <div class="footer">
    <span>Copyright © 2018-2022  京ICP备09032638号-46</span>
    <!-- <span>商务合作邮箱：jiaoyanxitong@100tal.com</span> -->
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  margin: 0;
  width: 100%;
  min-height: 94px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #878d99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span {
    line-height: 25px;
    margin-top: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/videoShare/components/footer.vue